var _rect, _path, _circle, _rect2, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotiCanceled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7665 3.98257C13.0094 4.08325 13.2302 4.23081 13.4161 4.41682L19.5841 10.5838C19.7703 10.7698 19.918 10.9906 20.0187 11.2336C20.1195 11.4767 20.1713 11.7372 20.1713 12.0003C20.1713 12.2634 20.1195 12.524 20.0187 12.767C19.918 13.0101 19.7703 13.2309 19.5841 13.4168L13.4161 19.5838C13.2302 19.7698 13.0094 19.9174 12.7665 20.0181C12.5235 20.1187 12.2631 20.1706 12.0001 20.1706C11.7371 20.1706 11.4767 20.1187 11.2337 20.0181C10.9908 19.9174 10.77 19.7698 10.5841 19.5838L4.4161 13.4168C4.22994 13.2309 4.08225 13.0101 3.98149 12.767C3.88072 12.524 3.82886 12.2634 3.82886 12.0003C3.82886 11.7372 3.88072 11.4767 3.98149 11.2336C4.08225 10.9906 4.22994 10.7698 4.4161 10.5838L10.5841 4.41682C10.77 4.23081 10.9908 4.08325 11.2337 3.98257C11.4767 3.8819 11.7371 3.83008 12.0001 3.83008C12.2631 3.83008 12.5235 3.8819 12.7665 3.98257ZM11.293 13.7069C11.4805 13.8945 11.7349 13.9998 12.0001 13.9998C12.2653 13.9998 12.5197 13.8945 12.7072 13.7069C12.8947 13.5194 13.0001 13.265 13.0001 12.9998V7.99982C13.0001 7.7346 12.8947 7.48025 12.7072 7.29271C12.5197 7.10517 12.2653 6.99982 12.0001 6.99982C11.7349 6.99982 11.4805 7.10517 11.293 7.29271C11.1055 7.48025 11.0001 7.7346 11.0001 7.99982V12.9998C11.0001 13.265 11.1055 13.5194 11.293 13.7069ZM11.293 16.7069C11.4805 16.8945 11.7349 16.9998 12.0001 16.9998C12.2653 16.9998 12.5197 16.8945 12.7072 16.7069C12.8947 16.5194 13.0001 16.265 13.0001 15.9998C13.0001 15.7346 12.8947 15.4802 12.7072 15.2927C12.5197 15.1052 12.2653 14.9998 12.0001 14.9998C11.7349 14.9998 11.4805 15.1052 11.293 15.2927C11.1055 15.4802 11.0001 15.7346 11.0001 15.9998C11.0001 16.265 11.1055 16.5194 11.293 16.7069Z",
    fill: "#FF5630"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 12,
    r: 10,
    fill: "#FF5630"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 7,
    width: 2,
    height: 6,
    rx: 1,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 16,
    r: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotiCanceled);
export default __webpack_public_path__ + "static/media/noti_canceled.82daf77e4f7879374e57431bb79a1c90.svg";
export { ForwardRef as ReactComponent };